import {
  Box,
  Typography,
  Breadcrumbs,
  Grid,
  Tooltip,
  Divider,
  Button,
} from "@mui/material";
import {
  searchStoreActions,
  selectFilter,
  selectStores,
} from "features/searchStore/saga/searchStoreSlice";
import {
  ListSection,
  SideContentSection,
} from "features/searchStore/sections/SearchResult";
import { Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { HelpOutline, Home, Search } from "@mui/icons-material";
import LandscapeNavbar from "features/searchStore/components/LandscapeNavbar";

export function LandscapeView() {
  const filter = useAppSelector(selectFilter);

  return (
    <Box
      display="flex"
      width="1000px"
      flexDirection="column"
      position="relative"
    >
      {/* Header */}
      <LandscapeNavbar />

      <Box
        px={5}
        py={1}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        borderBottom={1}
        borderTop={1}
        borderColor="divider"
      >
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />}>
          <Typography
            component={Link}
            to="/"
            variant="body1"
            color="black"
            sx={{
              textDecoration: "none",
              display: "flex",
              alignItems: "center",
              "&:hover": {
                textDecoration: "underline",
                color: "primary.main",
              },
            }}
          >
            <Home color="primary" sx={{ mr: 0.5 }} fontSize="small" />
            ホーム
          </Typography>
          {filter.area && (
            <Typography variant="body1">{filter.area.label}</Typography>
          )}
        </Breadcrumbs>
        {/* <Typography>20321</Typography> */}
      </Box>

      {/* Main content */}
      <Box display="flex" flexDirection="column" py={3} alignItems="center">
        <Grid container spacing={1}>
          <Grid item xs={3}>
            <SideContentSection />
            {/* <SideContentSection /> */}
          </Grid>

          <Grid item xs={9}>
            <ListSection />
          </Grid>
        </Grid>
      </Box>

      {/* Helper link */}

      {/* Footer */}
    </Box>
  );
}
